import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import '../../css/pages/Header.css';
import logo from '../../assets/images/logo.webp';
import facebook from '../../assets/images/social_logos/facebook.webp';
import instagram from '../../assets/images/social_logos/instagram.webp';
import { LanguageDropdown } from '../visualComponent/LanguageDropdown';
import { ContactButton } from '../visualComponent/ContactButton';
import { useLanguage } from '../../services/LanguageContextProvider';
import { localizedPath } from '../../i18n/locales';

export const Header = ({ variant = 'home' }) => {
    const { t } = useTranslation("global");
    const { language } = useLanguage();
    const home = localizedPath(language);
    const [menuOpen, setMenuOpen] = useState(false);

    // The hero IS the header background (`.header-container`). The horeca page
    // overrides the image + copy so it doesn't mirror the home hero.
    const isHoreca = variant === 'horeca';
    const heroTitle = t(isHoreca ? 'horeca.hero.title' : 'header.text.title');
    const heroSubtitle = t(isHoreca ? 'horeca.hero.subtitle' : 'header.text.subtitle');
    const containerStyle = isHoreca
        ? { backgroundImage: `url(${process.env.PUBLIC_URL}/horeca/horeca_hero.webp)` }
        : undefined;

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, []);

    const closeMenu = () => setMenuOpen(false);

    return (
        <>
            <section className='header-container' style={containerStyle}>
                <div className='header-navbar-container'>
                    <div className='header-navbar-logo'>
                        <Link to={home}><img src={logo} alt='Åby Crispbread logo' /></Link>
                        <div className='vertical-line first-vertical'></div>
                        <a href='https://www.facebook.com/abyfoods/'>
                            <img className='header-navbar-social' src={facebook} alt='Facebook profile link' />
                        </a>
                        <a href='https://instagram.com/abyfoods?igshid=MWZjMTM2ODFkZg=='>
                            <img className='header-navbar-social' src={instagram} alt='Instagram profile link' />
                        </a>
                        <div className='vertical-line'></div>
                    </div>

                    <button
                        type='button'
                        className='header-navbar-toggle'
                        aria-label={t('header.navbar.menuLabel')}
                        aria-expanded={menuOpen}
                        aria-controls='header-nav-drawer'
                        onClick={() => setMenuOpen((open) => !open)}
                    >
                        <span className='header-navbar-toggle-bar'></span>
                        <span className='header-navbar-toggle-bar'></span>
                        <span className='header-navbar-toggle-bar'></span>
                    </button>

                    <div
                        id='header-nav-drawer'
                        className={`header-navbar-links${menuOpen ? ' open' : ''}`}
                    >
                        <ul>
                            <li><Link to={`${home}#history-section`} onClick={closeMenu}>{t('header.navbar.linkAby')}</Link></li>
                            <li><Link to={`${home}#product-section`} onClick={closeMenu}>{t('header.navbar.linkProducts')}</Link></li>
                            <li><Link to={localizedPath(language, 'horeca')} onClick={closeMenu}>{t('header.navbar.linkHoreca')}</Link></li>
                            <li><Link to={`${home}#contact-section`} onClick={closeMenu}>{t('header.navbar.linkOrder')}</Link></li>
                            <li><LanguageDropdown /></li>
                        </ul>
                    </div>
                </div>
                <div className={`header-text${isHoreca ? ' header-text--horeca' : ''}`}>
                    <h1 className='header-text-title'>{heroTitle}</h1>
                    <p className='header-text-subtitle'>{heroSubtitle}</p>
                    {!isHoreca && (
                      <div className='header-text-buttons'>
                        <ContactButton buttonText={t('header.button.products')} cssClass={'header-text-button'} sectionId={"product-section"}/>
                        <ContactButton buttonText={t('header.button.order')} cssClass={'header-text-button black-white'} sectionId={"contact-section"}/>
                      </div>
                    )}
                </div>
            </section>
        </>
    )
}
